import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/ballot/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/ballot/create',
      data,
      dataType: 'form'
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/ballot/create',
      data,
      dataType: 'form'
    });
  },
  updateEnabled(data) {
    return http.post({
      url: '/la/admin/ballot/update/enabled',
      data,
      dataType: 'form'
    });
  }
};
